import React from 'react'
import { Card, Divider, Space, Typography } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faCalendarAlt, faTrash } from '@fortawesome/free-solid-svg-icons'
import CustomButton from '../../../../reusable-components/CustomButton'
import CoreEnums from '../../../../../core/utils/enums'
import { handleCancelBooking } from '../../../../lib/booking-utils'
import { handleOpenBooking, handleSkipScreening } from '../../../utils/appointments-calendar-lib'
import { isDoctor } from '../../../../lib/profile-utils'
import { getViewRecordText } from '../utils'

const { Title } = Typography

const ActionsCard = ({
  rescheduling,
  setRescheduling,
  updatingBooking,
  rescheduleDate,
  rescheduleTime,
  handleReschedule,
  resetRescheduleData,
  recordData,
  setLoading,
  dispatch,
  onFail,
  onSuccess,
  data,
  authState,
  updateBooking,
  onAfterCancel,
  token
}) => (
  <Card
    style={{
      borderRadius: '8px',
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
      height: 'fit-content'
    }}
    bodyStyle={{ padding: '20px' }}
  >
    <Title
      level={5}
      style={{
        margin: '0 0 20px 0',
        color: token.colorText,
        textAlign: 'center'
      }}
    >
      Actions
    </Title>

    <Space direction='vertical' style={{ width: '100%' }} size='middle'>
      {rescheduling ? (
        <>
          <CustomButton
            type='success'
            style={{
              width: '100%',
              height: '48px',
              borderRadius: '8px',
              fontWeight: '600',
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              border: 'none'
            }}
            loading={updatingBooking}
            disabled={!rescheduleDate || !rescheduleTime}
            text='Confirm Reschedule'
            onClick={handleReschedule}
          />
          <CustomButton
            type='default'
            style={{
              width: '100%',
              height: '48px',
              borderRadius: '8px',
              fontWeight: '600',
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              backgroundColor: '#fff2f0',
              border: '1px solid #ffccc7',
              color: '#ff4d4f'
            }}
            text='Cancel'
            onClick={resetRescheduleData}
          />
        </>
      ) : (
        <>
          <CustomButton
            type='primary'
            style={{
              width: '100%',
              height: '48px',
              borderRadius: '8px',
              fontWeight: '600',
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              backgroundColor: token.colorPrimary,
              borderColor: token.colorPrimary
            }}
            text={
              <>
                <FontAwesomeIcon icon={faEye} style={{ marginRight: '8px' }} />
                {getViewRecordText(data.status, isDoctor(), false, false)}
              </>
            }
            onClick={() => {
              setLoading(true)
              handleOpenBooking(recordData, dispatch, onFail, onSuccess)
            }}
          />

          {recordData.status !== CoreEnums.bookingStatuses.completed && (
            <CustomButton
              type='primary'
              style={{
                width: '100%',
                height: '48px',
                borderRadius: '8px',
                fontWeight: '600',
                fontSize: '14px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                backgroundColor: token.colorPrimary,
                borderColor: token.colorPrimary
              }}
              text={
                <>
                  <FontAwesomeIcon icon={faCalendarAlt} style={{ marginRight: '8px' }} />
                  Reschedule
                </>
              }
              onClick={() => setRescheduling(true)}
            />
          )}

          {isDoctor() && recordData.status === CoreEnums.bookingStatuses.screening && (
            <CustomButton
              type='warning'
              style={{
                width: '100%',
                height: '48px',
                borderRadius: '8px',
                fontWeight: '600',
                fontSize: '14px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                backgroundColor: token.colorWarning,
                borderColor: token.colorWarning,
                color: '#fff'
              }}
              text='Skip Screening'
              hasPopconfirm
              popConfirmTitle='Skip Screening'
              popConfirmDescription='Are you sure you want to skip the screening step? This action cannot be undone.'
              onClick={() => {
                setLoading(true)
                handleSkipScreening(recordData, dispatch, onFail, onSuccess)
              }}
            />
          )}

          <Divider style={{ margin: '20px 0' }} />

          <CustomButton
            type='danger'
            style={{
              width: '100%',
              height: '48px',
              borderRadius: '8px',
              fontWeight: '600',
              fontSize: '14px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
              backgroundColor: '#fff2f0',
              border: '1px solid #ffccc7',
              color: '#ff4d4f'
            }}
            text={
              <>
                <FontAwesomeIcon icon={faTrash} style={{ marginRight: '8px' }} />
                Cancel Booking
              </>
            }
            disabled={
              recordData.status !== CoreEnums.bookingStatuses.checkin &&
              recordData.status !== CoreEnums.bookingStatuses.screening
            }
            onClick={() => {
              handleCancelBooking(authState, recordData, updateBooking, onAfterCancel, token)
            }}
          />
        </>
      )}
    </Space>
  </Card>
)

export default ActionsCard
